// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"3448": "vendor-doc-parsing","5560": "main-dashboard","6243": "vendor-flowchart","7527": "vendor-canvas","8850": "vendor-common","9905": "vendor-rich-text",}[chunkId] || chunkId) + ".bundle." + __webpack_require__.h().slice(0, 6) + ".js"
}